export const formatNumberWithSpaces = (
  value: number | string | undefined
): string => {
  if (!value) {
    return 'N/A';
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
